import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	HomepageSocialPostGenerateAiImage,
	type HomepageSocialPostGenerateAiImageMutation,
	type HomepageSocialPostGenerateAiImageMutationVariables,
} from './generateAiPetitionImage.graphql';

/**
 * Kicks off a background AI image job for the generated draft, seeded with the petition title.
 * Failures resolve to null rather than throwing — the image is a nice-to-have on top of the
 * draft, so a flaky image service must never block the SAP handoff.
 */
export async function generateAiPetitionImage(
	input: { title: string },
	utilityContext: UtilityContext,
): Promise<{ responseId: string } | null> {
	const {
		gql: { fetch },
		errorReporter,
	} = utilityContext;

	try {
		const { data } = await fetch<
			HomepageSocialPostGenerateAiImageMutation,
			HomepageSocialPostGenerateAiImageMutationVariables
		>({
			query: HomepageSocialPostGenerateAiImage,
			path: '/generate-ai-petition-image',
			variables: {
				input: {
					title: input.title,
					description: '',
					backgroundMode: true,
				},
			},
			rejectOnError: true,
		});

		if (data.generateAiPetitionImage.__typename !== 'GenerateAiPetitionImageBackgroundSuccess') return null;

		return { responseId: data.generateAiPetitionImage.responseId };
	} catch (error: unknown) {
		void errorReporter.report({
			error: error instanceof Error ? error : new Error('homepage_social_post_generate_ai_image_failed'),
		});
		return null;
	}
}
